import { StyledLink } from './styles';

export const webServicesData = {
  mainText:
    'Take your digital presence to the next level with our high-end web development solutions!',
  description: `
    Looking for a team able to create <b>beautiful yet technologically advanced websites and web apps?</b>
    Look no further as the Rumble Fish expert team has everything it takes to develop sleek and 
    powerful digital products that stand out from the competition and <b>boost your business.</b> 
    Regardless of your project scope we always strive to deliver websites your customers will love!
    <br /><br />
    We offer <b>custom web development services</b> tailored precisely to your business needs and requirements. 
    Need a unique web application development? Or maybe your product is a huge platform with lots 
    of integration required to work properly? No matter what your concept is, we’ve got you covered!
  `,
  services: [
    {
      title: 'Customer web portal development',
      customData: (
        <>
          A web-based customer portal provides a unified platform for accessing
          organized details about your products or services, along with
          self-service options and communication tools, all in one place. A
          well-designed and developed client portal allows your business to
          provide constant access to all relevant information, customer support,
          and web analytics to enhance and enrich customer experience. At Rumble
          Fish, we have extensive experience <b>building custom web portals </b>
          for various industries and companies of all sizes - from startups to
          global corporations.
          <br />
          <br />
          Some of the functionalities we can add to your custom portal:
          <ul>
            <li>
              <StyledLink to="/services/ai-chat-assistant/">
                AI Chatbot Assistant
              </StyledLink>
            </li>
            <li>Online payments</li>
            <li>Live chat with a consultant</li>
            <li>Online catalog</li>
            <li>Personalized content</li>
            <li>Automatic alerts and notifications</li>
            <li>Flexible pricing modules</li>
            <li>Collaboration feature</li>
            <li>Intranet</li>
            <li>After-sales service</li>
            <li>Custom analytics and reporting</li>
          </ul>
        </>
      ),
    },
    {
      title: 'Corporate websites development',
      description: `
        Revamping your corporate online presence is a huge undertaking and quite an investment. 
        That’s why it’s important to do it with the right team. At Rumble Fish, we understand 
        the importance of having a sleek, yet technologically intricate and fast website. 
        We can cover the process at all stages - from wireframing and design to back-end and 
        front-end development. If your website is more like a portal with login functionalities 
        for your customers and/or employees - we’re here to take care of the security and 
        integration with CRM platforms like Hubspot or SalesForce. 
        Try website development with Rumble Fish!
      `,
    },
    {
      title: 'Custom web & web application development',
      description: `
        Rumble Fish offers full-cycle custom web & web app development. We’re here for you & your 
        business every step of the way - from ideation and design to integration to 
        maintenance and support. We build future-proof custom solutions that stand 
        out, regardless of the project’s scale or complexity.
        <br />
        With a team of software developers, UI/UX designers, DevOps engineers, and 
        QA specialists, we are ready to take full ownership of your project and 
        deliver a product that will exceed your expectations. 
      `,
    },
    {
      title: 'UI/UX design services',
      description: `
        At Rumble Fish, we recognize the pivotal role a stellar UI/UX plays in determining 
        the success of your digital product. The first impression sets the tone, and there's no 
        room for second chances. That's why a seamless user experience is paramount. 
        Your brand's reputation hinges on captivating your customers from the get-go – 
        it's all about making that first impression count!
        <br />
        Rumble Fish provides a comprehensive suite of UI/UX services aimed at crafting a distinctive, 
        user-centric, and reliable brand that sets you apart in the market. Whether it's conducting 
        UX research or delivering comprehensive product design solutions, we're here for you every step of the way. 
        Our objective is to ensure your solution remains effortlessly navigable and user-friendly, 
        even in the face of complexity and technological sophistication.
        <br />
        <br />
      `,
      linkTo: '/services/product-design/',
      linkText: 'See the full scope of our UI/UX design services',
    },
  ],
};
